import React from 'react';

export default function CheckInbox() {
  return (
    <div className="container">
      <h1>Enhanced UIO</h1>
      <h2>Check Your Inbox</h2>
      <p>
        An access link has been sent to your email from{' '}
        <strong>theduke@agentmail.to</strong>
      </p>
      <p className="info" style={{ marginTop: 16 }}>
        The link will expire in 24 hours.
      </p>
      <div className="footer">Internal Tool</div>
    </div>
  );
}
